import {IPostAction} from './IPostAction';

export class EmptyAction implements IPostAction {
    public execute(payload: Record<string, any>): void {
    }
}
